var _path, _path2, _path3, _path4, _path5, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.572 6.1c-2.4-1.378-2.91 2.025-3.003 4.258-.043.985 0 1.73 0 1.73v16.526c0 .929-.308 1.846-.985 2.375-.64.504-1.452.984-2.381.984a3.37 3.37 0 0 1-3.372-3.36V6.2a3.358 3.358 0 0 1 3.366-3.36c.634 0 1.224.173 1.729.474.006.006.012.006.018.012L16.572 6.1z",
    fill: "url(#qwrjyi068a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.212 20.812 11.686 31.715a3.351 3.351 0 0 1-4.985-3.027l.142-5.378c-.037 2.75 3.212 1.526 5.2.523.812-.412 1.415-.788 1.495-.837 0 0 .006 0 .006-.006l14.394-8.036a3.359 3.359 0 0 1 4.56 1.292 3.345 3.345 0 0 1-1.286 4.566z",
    fill: "url(#cggm3kr86b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.544 23.002c-.08.05-.683.425-1.495.837l1.495-.837z",
    fill: "url(#nwxvitcusc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.566 23.384c2.406-1.335-.277-3.544-2.142-4.769-.818-.535-1.483-.886-1.483-.886L8.8 9.263c-.794-.474-1.422-1.206-1.532-2.061-.099-.806-.099-1.742.375-2.535A3.355 3.355 0 0 1 12.24 3.51l19.188 11.487a3.35 3.35 0 0 1-.13 5.827c-.006.006-.012.006-.018.012l-4.714 2.548z",
    fill: "url(#agjfxz7vnd)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0tbm1h6h6e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 13,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.243 1.307H5.23v18.545h12.013V1.307z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0tbm1h6h6e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.578 6.1c-2.4-1.378-2.91 2.025-3.003 4.258-.043.985 0 1.73 0 1.73v16.526c0 .929-.308 1.846-.984 2.375-.64.504-1.453.984-2.382.984a3.37 3.37 0 0 1-3.372-3.36V6.2a3.358 3.358 0 0 1 3.366-3.36c.634 0 1.224.173 1.73.474.005.006.011.006.018.012L16.578 6.1z",
    fill: "url(#r1mjhmcg3f)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qwrjyi068a",
    x1: 11.703,
    y1: 2.839,
    x2: 11.703,
    y2: 31.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#5376ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#4764D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#3347A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#192065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06043A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cggm3kr86b",
    x1: 6.701,
    y1: 23.336,
    x2: 32.932,
    y2: 23.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#5376ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#4764D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#3347A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#192065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06043A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nwxvitcusc",
    x1: 12.045,
    y1: 23.418,
    x2: 13.543,
    y2: 23.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#577DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "agjfxz7vnd",
    x1: 31.826,
    y1: 20.878,
    x2: 6.888,
    y2: 5.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#5376ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#4764D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#3347A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#192065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06043A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r1mjhmcg3f",
    x1: 11.704,
    y1: 2.839,
    x2: 11.704,
    y2: 31.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#5376ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#4764D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#3347A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#192065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#06043A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6c46319093cc3355a6b4e0385b647a98.svg";
export { ForwardRef as ReactComponent };